// extracted by mini-css-extract-plugin
export default {"questions-table__heading":"QuestionsTable_questions-table__heading__UGbbL","questions-table__content":"QuestionsTable_questions-table__content__zpASO"};